import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfflineMapService {
  private refreshSubject  = new Subject<void>();
  private manualRefreshSubject  = new Subject<void>();
  private refreshSummarySubject = new Subject<void>();
  private removeDraggedSvgSubject  = new Subject<void>();
  private testRoutSubject  = new Subject<any>();
  private drawTestRouteSubject = new Subject<any>();

  refresh(): any {
    this.refreshSubject.next();
  }

  removeDraggedSvg(): any {
    this.removeDraggedSvgSubject.next();
  }

  testRoute(testRoute): any {
    this.testRoutSubject.next(testRoute);
  }

  drawTestRoute(paths): any {
    this.drawTestRouteSubject.next(paths);
  }

  manualRefresh(): any {
    this.manualRefreshSubject.next();
  }

  refreshSummary(): any {
    this.refreshSummarySubject.next();
  }

  onRefresh(): Observable<any> {
    return this.refreshSubject.asObservable();
  }

  onRemoveDraggedSvg(): Observable<any> {
    return this.removeDraggedSvgSubject.asObservable();
  }

  onTestRoute(): Observable<any> {
    return this.testRoutSubject.asObservable();
  }

  onDrawTestRoute(): Observable<any> {
    return this.drawTestRouteSubject.asObservable();
  }

  onRefreshSummary(): Observable<any> {
    return this.refreshSummarySubject.asObservable();
  }

  onManualRefresh(): Observable<any> {
    return this.manualRefreshSubject.asObservable();
  }
}
